var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{staticClass:"_pr-",attrs:{"cols":"9"}},[_c('ColorPickerV2',{attrs:{"title":"Cor do ingresso","colorSelected":_vm.selectedSection,"type":"item-background-color"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }